  
import { 
    LOGIN_SUCCESS,
    LOGOUT_SUCCESS,
    LOGOUT_FAIL,
    GET_PEOPLE_BY_PROJECTS, 
    GET_PEOPLE_BY_PROJECT, 
    GET_PEOPLE_BY_COMPANY, 
    GET_PEOPLE_BY_REQUESTS, 
    GET_PEOPLE_BY_REQUEST_COUNT,
    RESPOND_TO_REG_COMPANY_INVITATION, 
    UPDATE_USER_COMPANY_ROLE,
    CLEAR_PEOPLE,
    SELECT_PERSON,
    SET_COMPANY_INVITES
} from "../actions/types";

const initialState = {
  peopleInCompany: [],
  peopleInProjects: [],
  peopleRequests: [],
  peopleRequestCount: 0,
  people_favorites: [],
  companyInvites: [],
  person: {}
};

export default function (state = initialState, action) {
  switch (action.type) {
        // ensure no redux values linger between users ----
    case LOGIN_SUCCESS:
    case LOGOUT_SUCCESS:
    case LOGOUT_FAIL:
        return {
            ...initialState,
        }
    // ------------------------------------------------
    case GET_PEOPLE_BY_PROJECT:
      return {
        ...state,
        // people: action.payload.map(person => {...person, test: true})
        peopleInProjects: action.payload.map(person => person && {...person, card_open: false})
      };
    case GET_PEOPLE_BY_PROJECTS:
      return {
        ...state,
        // people: action.payload.map(person => {...person, test: true})
        peopleInProjects: action.payload.map(person => person && {...person, card_open: false})
      };
    case GET_PEOPLE_BY_COMPANY:
      return {
        ...state,
        peopleInCompany: action.payload.map(person => person && {...person, card_open: false})
      };
    case GET_PEOPLE_BY_REQUESTS:
      return {
        ...state,
        peopleRequests: action.payload.map(person => person && {...person, card_open: true})
      };
    case GET_PEOPLE_BY_REQUEST_COUNT:
      return {
        ...state,
        peopleRequestCount: action.payload.company_invitations
      };
    case SET_COMPANY_INVITES:
      return {
        ...state,
        companyInvites: action.payload
      };
    case SELECT_PERSON:
      return {
        ...state,
        peopleInCompany: state.peopleInCompany.map(person => person.user_id === action.payload ? {...person, card_open: !person.card_open} : person)
      };
    case RESPOND_TO_REG_COMPANY_INVITATION:
      return {
        ...state,
        peopleRequests: state.peopleRequests.filter(invite => invite.id !== action.payload),
        peopleRequestCount: state.peopleRequestCount - 1
      };
    case UPDATE_USER_COMPANY_ROLE:
      return {
        ...state,
        peopleInCompany: state.peopleInCompany.map(person => person.user_id === action.payload.id ? {...person, croles: action.payload.croles} : person)
      };
    case CLEAR_PEOPLE:
      return {
        ...initialState
      };
    default:
      return state;
  }
}